export default __webpack_public_path__ + "static/media/6.8ba5076e.webp";